import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Categories"],
  endpoints: (builder) => ({
    // Get all categories
    getCategories: builder.query({
      query: () => "/industry-category",
      transformResponse: (response) => response.data || response,
      providesTags: ["Categories"],
    }),

    //Get all categories with select fields
    getCategoriesSelect: builder.query({
      query: () => "/industry-category?mode=select",
      transformResponse: (response) => response.data || response,
      providesTags: ["Categories"],
    }),

    // Get a single Category
    getCategoryById: builder.query({
      query: (id) => `/industry-category/${id}`,
      transformResponse: (response) => response.data || response,
      providesTags: (result, error, id) => [{ type: "categories", id }],
    }),

    // Create a new Category
    createCategory: builder.mutation({
      query: (category) => ({
        url: `/industry-category`,
        method: "POST",
        body: category,
      }),
      transformResponse: (response) => response.data || response,
      invalidatesTags: ["Categories"],
    }),

    // Update an existing Category
    updateCategory: builder.mutation({
      query: ({ id, ...category }) => ({
        url: `/industry-category/${id}`,
        method: "PUT",
        body: category,
      }),
      invalidatesTags: ["Categories"],
    }),

    // Delete an existing Category
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/industry-category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Categories"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoriesSelectQuery,
  useGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;
